import script from "./CompromissosSecao.vue?vue&type=script&setup=true&lang=js"
export * from "./CompromissosSecao.vue?vue&type=script&setup=true&lang=js"

import "./CompromissosSecao.vue?vue&type=style&index=0&id=1f474430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f474430"]])

export default __exports__